import { useState } from "react";
import { toast } from "../lib/notify";
import { UserPlus, KeyRound, Copy } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const cls = "px-2 py-1.5 text-xs border border-slate-300 rounded-md bg-white outline-none focus:border-orange-500";

export function CreatedList({ items }) {
  if (!items.length) return null;
  return (
    <div className="text-xs border border-emerald-300 bg-emerald-50 rounded-md px-3 py-2 space-y-1.5" data-testid="sub-user-created">
      {items.map((d) => (
        <div key={d.email} className="space-y-0.5" data-testid={`sub-user-created-${d.email}`}>
          <div className="font-semibold text-emerald-800 inline-flex items-center gap-1"><KeyRound className="w-3.5 h-3.5" /> {d.email} hesabı açıldı · e-posta: {d.mail_status === "sent" ? "gönderildi" : "gönderilemedi"}</div>
          <div className="font-mono text-[11px] inline-flex items-center gap-2 ml-5">Geçici şifre: <b data-testid="sub-user-temp-password">{d.temp_password}</b>
            <button type="button" onClick={() => { navigator.clipboard?.writeText(d.temp_password); toast.success("Kopyalandı"); }} className="p-0.5 hover:text-emerald-900" title="Kopyala"><Copy className="w-3 h-3" /></button></div>
        </div>
      ))}
      <div className="text-[10px] text-slate-500">İlk girişte şifre değiştirme zorunlu.</div>
    </div>
  );
}

// Taşeronlar detayı: tek tıkla taşeron rolünde hesap + geçici şifre e-postası. "Kaydet & Yeni" formu boşaltıp açık tutar, "Kaydet & Kapat" formu kapatır; açılan hesaplar listede kalır.
export default function SubUserCreate({ cari, onCreated }) {
  const blank = () => ({ name: cari.contact || cari.name, email: "", phone: "" });
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const [created, setCreated] = useState([]);
  const save = async (closeAfter) => {
    if (!f.name.trim() || !f.email.trim()) { toast.error("Ad Soyad ve e-posta zorunlu"); return; }
    setBusy(true);
    try {
      const { data } = await http.post(`/subcontractors/${cari.id}/create-user`, f);
      setCreated((c) => [...c, data]);
      setTimeout(() => setCreated((c) => c.filter((x) => x.email !== data.email)), 10 * 60 * 1000);   // geçici şifre ekranda en fazla 10 dk kalır
      toast.success(data.mail_status === "sent" ? "Hesap açıldı — geçici şifre e-posta ile gönderildi" : "Hesap açıldı — e-posta gönderilemedi, şifreyi elle iletin");
      setF(blank());
      if (closeAfter) setOpen(false);
      onCreated?.();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2">
      <CreatedList items={created} />
      {!open
        ? <button type="button" onClick={() => setOpen(true)} data-testid="sub-user-create-open" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-600 text-white text-xs font-bold hover:bg-orange-700"><UserPlus className="w-3.5 h-3.5" /> Taşeron Kullanıcısı Oluştur</button>
        : (
          <form onSubmit={(e) => { e.preventDefault(); save(false); }} className="flex items-end gap-2 flex-wrap border border-orange-300 bg-orange-50 rounded-md p-2" data-testid="sub-user-create-form">
            <input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Ad Soyad" data-testid="sub-user-name" className={cls} />
            <input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="E-posta" data-testid="sub-user-email" className={cls} />
            <input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Telefon" data-testid="sub-user-phone" className={cls} />
            <button type="submit" disabled={busy} data-testid="sub-user-save" title="Hesabı aç, geçici şifreyi e-postala ve bir sonraki kullanıcı için formu boşalt"
              className="px-3 py-1.5 rounded-md bg-orange-600 text-white text-xs font-bold hover:bg-orange-700 disabled:opacity-50">{busy ? "Oluşturuluyor…" : "Kaydet & Yeni"}</button>
            <button type="button" disabled={busy} onClick={() => save(true)} data-testid="sub-user-save-close" title="Hesabı aç, geçici şifreyi e-postala ve formu kapat"
              className="px-3 py-1.5 rounded-md border border-orange-600 text-orange-700 bg-white text-xs font-bold hover:bg-orange-100 disabled:opacity-50">Kaydet & Kapat</button>
            <button type="button" onClick={() => { setOpen(false); setF(blank()); }} data-testid="sub-user-cancel" className="px-2 py-1.5 text-xs text-slate-600">İptal</button>
            <span className="text-[10px] text-slate-500 basis-full">Hesap açılır, geçici şifre e-posta ile gönderilir; ilk girişte şifre değiştirme zorunludur.</span>
          </form>
        )}
    </div>
  );
}
